import React from 'react';
import { Translate } from '../common/Translate';

const PaymentHeader = props => {

    return (
        <div className="generic-detail__header-row">
            <div className="generic-detail__header-th generic-detail__header-th--payment-description">
                <Translate>Aciklama</Translate>
            </div>
            <div className="generic-detail__header-th generic-detail__header-th--payment-date">
                <Translate>Date</Translate>
            </div>
            <div className="generic-detail__header-th generic-detail__header-th--payment-amount">
                <Translate>Tutar</Translate>
            </div>
            <div className="generic-detail__header-th generic-detail__header-th--payment-source">
                <Translate>Banka</Translate>
            </div>
            <div className="generic-detail__header-th generic-detail__header-th--payment-buttons">
             
            </div>
        </div>
    )
}

export default PaymentHeader;